import { InvokeType } from '@g2-shared/api-client/generated/risk-app';

export const UserInvokeTypeMapper: Record<InvokeType, string> = {
  [InvokeType.AgentRiskDebtLimitModelAssignment]: 'Assignment_invoke',
  [InvokeType.AgentRiskDebtLimitModelRemoveAssignment]: 'Remove_assignment_invoke',
  [InvokeType.AgentRiskDownPaymentSet]: 'Downpayment_set_invoke',
  [InvokeType.AgentRiskTemporaryDebtLimitIncreaseAddition]: 'Increase_limit_invoke',
  [InvokeType.AgentRiskTemporaryDebtLimitIncreaseRemoval]: 'Remove_increase_limit_invoke',
  [InvokeType.DebtLimitModelCreation]: 'Creation_invoke',
  [InvokeType.DebtLimitModelDeactivation]: 'Deactivation_invoke',
  [InvokeType.DebtLimitModelPlanedDebtLimitIncreaseAddition]: 'Planned_increase_limit_invoke',
  [InvokeType.DebtLimitModelPlanedDebtLimitIncreaseRemoval]: 'Remove_planned_increase_limit_invoke',
  [InvokeType.AgentDebtRiskServiceSupportAddition]: 'Add_service_support_invoke',
  [InvokeType.AgentDebtRiskServiceSupportRemoval]: 'Remove_service_support_invoke',
  [InvokeType.DebtLimitModelDeletion]: 'Deletion_invoke',
};
